var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBomb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E24A40;}\n\t.st1{fill:#5F6062;}\n\t.st2{fill:#FDB614;}\n\t.st3{fill:#013047;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.7,352.1C290.7,352.1,290.7,352.1,290.7,352.1L75.4,567.5c0,0,0,0,0,0c-96.5,96.5-99,251.4-7.7,350.9 c98,106.8,266.3,108.3,368.8,5.8L649.7,711c49.4-49.4,74.2-114.2,74.3-179c0-0.1,0.1-0.2,0.2-0.2l96.2,0.1c5.4,0,10.6-2.1,14.4-5.9 L996,364.7c5.4-5.4,3.1-14.7-4.3-16.9l-259.6-78c-0.1,0-0.1-0.1-0.1-0.1L656.8,7.4c-2.1-7.4-11.5-9.9-16.9-4.4L477.3,165.5 c-3.8,3.8-5.9,8.9-5.9,14.3l-0.3,97.7c0,0.1-0.1,0.2-0.2,0.2C405.7,277.6,340.4,302.4,290.7,352.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,927c99.5,98.8,261.1,96.6,360.2-2.6L542,818.7L183.1,459.8L75.4,567.5c0,0,0,0,0,0 C-23.9,666.8-23.7,828,76,927z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 229.7,
    cy: 772,
    r: 137.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.2,808.4c12.2,3.3,25.7,0.1,35.3-9.5l46.5,46.5c5.7,5.7,5.7,15.1-0.6,20c-25.5,19.8-57.2,27.7-87.7,23.5 c-8-1.1-12.6-9.2-10.6-17L219.2,808.4z M254.5,747.3c-4.7-4.7-10.4-7.8-16.4-9.5l17.1-63.6c2.1-7.8,10.1-12.5,17.6-9.5 c14.1,5.7,27.2,14.3,38.6,25.6c11.4,11.4,20,24.6,25.6,38.6c3,7.5-1.7,15.5-9.5,17.6L264,763.6 C262.4,757.6,259.3,752,254.5,747.3z M156.3,700.7l46.5,46.5c-9.6,9.6-12.7,23.1-9.5,35.3l-63.5,17c-7.8,2.1-15.9-2.6-17-10.6 c-4.2-30.5,3.7-62.2,23.5-87.7C141.2,695,150.6,695,156.3,700.7L156.3,700.7z M213.2,788.6c-8.6-8.6-8.6-22.4,0-31s22.4-8.6,31,0 c8.6,8.6,8.6,22.4,0,31C235.6,797.2,221.8,797.2,213.2,788.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.2529cfd4dc20edb1293938f8e5bf35ab.svg";
export { ForwardRef as ReactComponent };